import { render, staticRenderFns } from "./Audiobooks.vue?vue&type=template&id=18d5f2f7&"
import script from "./Audiobooks.vue?vue&type=script&lang=ts&"
export * from "./Audiobooks.vue?vue&type=script&lang=ts&"
import style0 from "./Audiobooks.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports